// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"40ae8e82","781":"206f98b4"}[chunkId] + ".chunk.css";
};